'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messages = require('common/messages');

var _dashboard = require('./dashboard.html');

var _dashboard2 = _interopRequireDefault(_dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _dashboard2.default,
  bindings: {
    adminMessage: '<',
    alerts: '<',
    companyMessage: '<',
    flex: '<',
    layout: '<'
  },
  controller: function () {
    function DashboardComponent($mdDialog, $scope, $state, AccountService, AdverseEventService, AdverseEventsService, AuthService, CompanyService, LoadingService, MessageService, RegulatorService, ReportService, ToastService, UsageDataService) {
      'ngInject';

      _classCallCheck(this, DashboardComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AccountService: AccountService,
        AdverseEventService: AdverseEventService,
        AdverseEventsService: AdverseEventsService,
        AuthService: AuthService,
        CompanyService: CompanyService,
        LoadingService: LoadingService,
        MessageService: MessageService,
        RegulatorService: RegulatorService,
        ReportService: ReportService,
        ToastService: ToastService,
        UsageDataService: UsageDataService
      });
    }

    _createClass(DashboardComponent, [{
      key: 'showUsages',
      value: function showUsages(quarterOnly) {
        var _this = this;

        var promise = void 0;
        if (quarterOnly) {
          promise = this.UsageDataService.getMissingQuarterUsageData();
        } else {
          promise = this.UsageDataService.getMissingUsageData();
        }

        promise.then(function (r) {
          var usages = r.data;

          if (usages && usages.length) {
            var scope = _angular2.default.extend(_this.$scope.$new(true), {
              usages: usages,
              onUsageDataUpdated: function onUsageDataUpdated($event) {
                return _this.onUsageDataUpdated($event);
              }
            });

            _this.$mdDialog.show({
              clickOutsideToClose: true,
              fullscreen: true,
              scope: scope,
              template: '\n          <md-dialog class="flex-85" style="max-height: 90%">\n            <md-dialog-content>\n              <dialog-close/>\n              <bulk-usage-data\n                usages="usages"\n                on-usages-submitted="onUsageDataUpdated($event)">\n              </bulk-usage-data>\n            </md-dialog-content>\n          </md-dialog>\n          '
            });
          } else {
            _this.$mdDialog.show(_this.$mdDialog.alert().clickOutsideToClose(true).textContent('You are currently in compliance. No further action is required.').ariaLabel('No action required').ok('OK'));
          }
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'onUsageDataUpdated',
      value: function onUsageDataUpdated($event) {
        var _this2 = this;

        if ($event && $event.usages) {
          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
            _this2.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
            _this2.$mdDialog.hide();
            _this2.$state.reload();
          }).catch(function (error) {
            return _this2.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showAttestment',
      value: function showAttestment() {
        var _this3 = this;

        this.AdverseEventsService.getOpenAdverseEventsPreviousMonth().then(function (r) {
          var adverseEvents = r.data;
          var scope = _angular2.default.extend(_this3.$scope.$new(true), {
            adverseEvents: adverseEvents,
            onAttested: function onAttested($event) {
              return _this3.onAttested($event);
            }
          });

          _this3.$mdDialog.show({
            clickOutsideToClose: true,
            fullscreen: true,
            scope: scope,
            template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content>\n                <dialog-close/>\n                <attest\n                  adverse-events="adverseEvents"\n                  on-attested="onAttested($event)">\n                </attest>\n              </md-dialog-content>\n            </md-dialog>\n          '
          });
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'onAttested',
      value: function onAttested(_ref) {
        var _this4 = this;

        var signature = _ref.signature;

        if (signature) {
          this.AdverseEventService.attest(signature).then(function () {
            _this4.ToastService.showSuccess(_messages.ADVERSE_EVENT_ATTESTED);
            _this4.$mdDialog.hide();
            _this4.$state.reload();
          }).catch(function (error) {
            return _this4.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showCompanyAdd',
      value: function showCompanyAdd() {
        var _this5 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onCompanyAdded: function onCompanyAdded($event) {
            return _this5.onCompanyAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <company-add-form\n                on-company-changed="onCompanyAdded($event)">\n              </company-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onCompanyAdded',
      value: function onCompanyAdded(_ref2) {
        var _this6 = this;

        var company = _ref2.company;

        if (company) {
          this.CompanyService.add(company).then(function (r) {
            _this6.$mdDialog.hide();
            _this6.ToastService.showSuccess(_messages.COMPANY_ADDED);

            var companyId = r.data.Id;
            _this6.$state.go('company', { id: companyId });
          }).catch(function (error) {
            return _this6.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showUserAdd',
      value: function showUserAdd() {
        var _this7 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          accessLevels: this.AuthService.getAccessLevels(),
          onUserAdded: function onUserAdded($event) {
            return _this7.onUserAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <user-add-form\n              require-user-type-selection="true"\n              access-levels="accessLevels"\n              on-user-changed="onUserAdded($event)">\n            </user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
        });
      }
    }, {
      key: 'onUserAdded',
      value: function onUserAdded(_ref3) {
        var _this8 = this;

        var user = _ref3.user;

        if (user) {
          this.AccountService.addAccount(user).then(function () {
            _this8.$mdDialog.hide();
            _this8.ToastService.showSuccess(_messages.USER_ADDED);
          }).catch(function (error) {
            return _this8.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'alertClicked',
      value: function alertClicked(_ref4) {
        var alert = _ref4.alert;

        if (alert) {
          if (alert.AlertTypeID === 1) {
            this.$state.go('products', { search: 'missing_info' });
          } else if (alert.AlertTypeID === 2) {
            this.$state.go('adverseEvents', { search: 'status_open' });
          } else if (alert.AlertTypeID === 3) {
            if (this.AuthService.isSysAdmin) {
              this.$state.go('products', { search: 'missing_sales' });
            } else {
              this.showUsages(false);
            }
          } else if (alert.AlertTypeID === 4) {
            if (this.AuthService.isSysAdmin) {
              this.$state.go('memberCompliance');
            } else {
              this.showAttestment();
            }
          }
        }
      }
    }, {
      key: 'showEditMessage',
      value: function showEditMessage(messageType) {
        var action = messageType === 'SYSTEM' ? this.onSystemMessageChanged.bind(this) : this.onCompanyMessageChanged.bind(this);

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          message: messageType === 'SYSTEM' ? this.adminMessage : this.companyMessage,
          title: messageType === 'SYSTEM' ? 'NASC Message' : 'Company Message',
          onMessageChanged: function onMessageChanged($event) {
            return action($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <message-edit message="message"\n                title="title"\n                on-message-changed="onMessageChanged($event)">\n              </message-edit>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onSystemMessageChanged',
      value: function onSystemMessageChanged(_ref5) {
        var _this9 = this;

        var message = _ref5.message;

        this.MessageService.updateAdminMessage(message).then(function () {
          _this9.$mdDialog.hide();
          _this9.ToastService.showSuccess(_messages.SYSTEM_MESSAGE_CHANGED);
          _this9.$state.reload();
        }).catch(function (error) {
          return _this9.ToastService.showError(error);
        });
      }
    }, {
      key: 'onCompanyMessageChanged',
      value: function onCompanyMessageChanged(_ref6) {
        var _this10 = this;

        var message = _ref6.message;

        this.MessageService.updateCompanyMessage(message).then(function () {
          _this10.$mdDialog.hide();
          _this10.ToastService.showSuccess(_messages.COMPANY_MESSAGE_CHANGED);
          _this10.$state.reload();
        }).catch(function (error) {
          return _this10.ToastService.showError(error);
        });
      }
    }, {
      key: 'showRegulatorAdd',
      value: function showRegulatorAdd() {
        var _this11 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onRegulatorAdded: function onRegulatorAdded($event) {
            return _this11.onRegulatorAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <regulator-add-form\n                dialog-title="Add New Regulator"\n                submit-title="Add Regulator"\n                on-regulator-changed="onRegulatorAdded($event)">\n              </regulator-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onRegulatorAdded',
      value: function onRegulatorAdded(_ref7) {
        var _this12 = this;

        var regulator = _ref7.regulator;

        if (regulator) {
          this.RegulatorService.add(regulator).then(function () {
            _this12.ToastService.showSuccess(_messages.REGULATOR_ADDED);
            _this12.$mdDialog.hide();
            _this12.$state.reload();
          }).catch(function (error) {
            return _this12.ToastService.showError(error);
          });
        }
      }
    }]);

    return DashboardComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/dashboard/dashboard.component.js